import styled from 'styled-components'

interface Props {
  flexDirection: string
}

export default styled.div<Props>`
  display: flex;
  width: 100%;
  gap: 24px;
  max-width: 100%;
  max-height: 100%;
  height: 100vh;
  flex-direction: ${(props) => props.flexDirection};
  overflow: auto;

  ::-webkit-scrollbar {
    width: 8px;
    background-color: #c4c4c4;
    border-radius: 50px;
  }
  ::-webkit-scrollbar-track {
    background: white;
    border: 0;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #c4c4c4;
    border-radius: 50px;
  }

  /* Estilo específico para o eixo horizontal */
  ::-webkit-scrollbar-thumb:horizontal {
    height: 4px; /* Altura do thumb no eixo X */
  }

  /* Estilo específico para o eixo vertical */
  ::-webkit-scrollbar-thumb:vertical {
    width: 4px; /* Largura do thumb no eixo Y */
  }
`
